import { render, staticRenderFns } from "./rewardTrafficPermitEdit.vue?vue&type=template&id=3384ea8a&scoped=true&"
import script from "./rewardTrafficPermitEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTrafficPermitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384ea8a",
  null
  
)

export default component.exports